import React from 'react';
import ProductThesaurusList from "../../../components/Admin/Product/ProductThesaurusList";

const AdminProductThesaurus = () => {

    return (
        <div>
            <main className="sl-main sl-mt-8">
                <div className={"sl-container sl-m-auto sl-my-8"}>

                    <h1 className={`sl-mb-10 sl-text-xl sl-text-gray-900`}>Product Thesaurus</h1>
                    <ProductThesaurusList></ProductThesaurusList>

                </div>
            </main>
        </div>
    );
};

export default AdminProductThesaurus;
